import { Link } from "react-router-dom";
import PageLayout from "@/components/feature/PageLayout";
import TechReportAccordion from "@/components/feature/TechReportAccordion";
import DryAlphaFeature from "@/components/feature/DryAlphaFeature";

export default function Report() {
  return (
    <PageLayout>
      <div className="relative py-14 md:py-20 bg-primary-700 overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=Professional%20modern%20workspace%20with%20technical%20documents%20spread%20across%20a%20clean%20wooden%20desk%2C%20scientific%20research%20materials%20and%20measurement%20charts%2C%20laptop%20displaying%20data%20graphs%2C%20warm%20desk%20lamp%20lighting%20creating%20intimate%20atmosphere%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style&width=1200&height=400&seq=factk-report-header-v2&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8">
          <div className="max-w-4xl mx-auto">
            <nav className="mb-4">
              <ol className="flex items-center gap-2 text-sm text-background-300">
                <li>
                  <Link to="/" className="hover:text-background-100 transition-colors">
                    ホーム
                  </Link>
                </li>
                <li>
                  <i className="ri-arrow-right-s-line text-xs" />
                </li>
                <li className="text-background-100">レポート</li>
              </ol>
            </nav>
            <h1 className="text-3xl md:text-4xl font-black text-background-50">レポート</h1>
            <p className="text-accent-300 text-sm mt-2">technical reports</p>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <TechReportAccordion />

          <div className="mt-8">
            <DryAlphaFeature />
          </div>
        </div>
      </div>
    </PageLayout>
  );
}